import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
export const otherClient = axios.create({
  baseURL: apiUrl,
  timeout: 60000,
});

// REQUEST INTERCEPTOR
otherClient.interceptors.request.use(
  (request) => {
    const authData = localStorage.getItem("auth");
    const parsed = authData ? JSON.parse(authData) : null;
    const accessToken = parsed?.tokens?.accessToken;

    if (accessToken) {
      request.headers.Authorization = `Bearer ${accessToken}`;
    }

    return request;
  },
  (error) => Promise.reject(error),
);

// RESPONSE INTERCEPTOR
otherClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);
